import React, { useState } from 'react';
import Modal from '../components/Modal';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LoadMask from "../Utils/LoadMask/LoadMask";
import NavbarModulo from '../components/NavbarModulo';

import {
    AsyncSelectField,
    AsyncSelectFieldIn
} from "../Utils/renderField/renderField";

function InformesForm(props) {
    const {
        modulo,
        loader,
        excelCosto,
        buscarPresupuesto,
        listarProyectosGestion,
        presupuestos
    } = props;

    const [estadoModalCosto, cambiarEstadoModalCosto] = useState(false);
    
    let titulo = 'Informes'
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const handleOnChangeProyecto = value => {
        buscarPresupuesto(value.value);
    };

    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
        
            <div className="container">
                <br/>
                <h4 className='mt-1' style={{ color: "white" }}>Informes</h4>
                <div className="row">
                    <div className="col-xxl-3">
                        <div className="list-group" id="list-tab" role="tablist">
                            <button class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalCosto(!estadoModalCosto)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Hoja técnica de proyectos
                            </button>
                        </div>
                    </div>
                </div>
                <Modal
                    estado={estadoModalCosto}
                    cambiarEstado={cambiarEstadoModalCosto}
                    titulo="Hoja técnica de proyectos"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='col-12'>
                                <Field
                                    name="proyecto"
                                    placeholder="Proyecto..."
                                    className="form-control-find"
                                    onChange={handleOnChangeProyecto}
                                    component={AsyncSelectField}
                                    loadOptions={listarProyectosGestion}
                                    msj="Proyecto"
                                />
                            </div>
                            <div className='col-12 mb-3'>
                                <Field
                                    name="presupuesto"
                                    placeholder="Presupuesto..."
                                    className="form-control-find"
                                    loadOptions={presupuestos}
                                    component={AsyncSelectFieldIn}
                                    msj="Presupuesto"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelCosto}
                                    >
                                    Exportar Excel
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn btn-secondary'
                                        onClick={() => cambiarEstadoModalCosto(false)}
                                    >
                                    Cancelar
                                    </button>
                                </div>
                            </Contenido>
                        </LoadMask>
                </Modal>
                
            </div>
        </div>
    );
}

InformesForm.propTypes = {
    loader: PropTypes.bool,
    modulo: PropTypes.object,
    reporteKardexValorizado: PropTypes.func,
    listarProductos: PropTypes.object,
};

export default reduxForm({
    form: 'FormInformesGestionProyecto',

})(InformesForm);


const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;
